import { render } from "./ContactAdvisorBlock.vue?vue&type=template&id=f2fe8a64"
import script from "./ContactAdvisorBlock.vue?vue&type=script&lang=js"
export * from "./ContactAdvisorBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__